import React from 'react';
import './Footer.css';

class Footer extends React.PureComponent {
  render() {
    return (
      <footer>
        <div>/ /</div>
      </footer>
    );
  }
}

export default Footer;
